import { pushAPI } from '../services/api';

export async function getVapidPublicKey() {
  const res = await pushAPI.getVapidKey();
  return res.data?.publicKey || null;
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export function getPermissionState() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
}

export async function getCurrentSubscription() {
  if (!isPushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function subscribePush() {
  if (!isPushSupported()) throw new Error('Push no soportado en este navegador');

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Permiso de notificaciones denegado');

  const vapidKey = await getVapidPublicKey();
  if (!vapidKey) throw new Error('No se pudo obtener la clave VAPID del servidor');

  const reg = await navigator.serviceWorker.ready;
  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidKey),
  });

  const subJson = subscription.toJSON();
  await pushAPI.subscribe({
    endpoint: subJson.endpoint,
    keys: subJson.keys,
  });

  return subscription;
}

export async function unsubscribePush() {
  const subscription = await getCurrentSubscription();
  if (subscription) {
    await pushAPI.unsubscribe(subscription.endpoint);
    await subscription.unsubscribe();
  }
}
